<template>
  <div class="auto-gam-resolution-table">
    <template
      v-if="
        actionButtonText == 'No GAM - Manual exisiting process need to followed'
      ">
      <Notification
        title="No GAM - Manual exisiting process need to followed"
        icon="info-circle"
        type="info"
        class="auto-gam-resolution-table__notification">
      </Notification>
    </template>
    <Table
      :default-columns="autoGamResolutionTableColumns"
      :row-data="getData"
      primary-key="charge_type"
      cell-background="#fff"
      header-cell-background="#f7f7f7"
      no-data-message="Auto gam resolution data is not present"
      has-select-checkbox
      :selected-rows="selectedRowByIds"
      @selectChangeEvent="selectChangeEvent"
      @updateActiveRow="updateActiveRowRecord"
      @checkIsDisabled="checkIsDisabled"
      @selectAllEvent="selectChangeEvent">
      <template #default="{ row, col }">
        <span v-if="col.slotKey === 'outcome'">
          <Select
            id="selectInput"
            :disabled="checkIsDisabled(row) || isGamPresent"
            :value="getOutcomeOptions(row[col.slotKey])"
            :options="autoResolutionOutcomeOptions"
            @input="onSelectOutcome($event, row)" />
        </span>
        <span
          v-else-if="
            (col.slotKey === 'expectedQuantity' ||
              col.slotKey === 'expectedAmount') &&
            (row?.isPotentialAccept == undefined || !row?.isPotentialAccept) &&
            row?.outcome == 'accept'
          ">
          <text-input
            label=""
            optional-label=""
            :error="validateAutoGamRow(row, col.slotKey) ? true : false"
            :error-message="validateAutoGamRow(row, col.slotKey)"
            :minimum-number="0.0"
            help-message=""
            :value="
              (row['charge_type'] == 'DMR' || row['charge_type'] == 'DET') &&
              col.slotKey === 'expectedQuantity'
                ? 1
                : row[col.slotKey]?.replaceAll('$', '')
            "
            :disabled="
              (row['charge_type'] == 'DMR' || row['charge_type'] == 'DET') &&
              col.slotKey === 'expectedQuantity'
            "
            @onChange="onTextChange($event, row, col.slotKey)" />
        </span>
        <span
          v-else
          v-tooltip="getTableCellValueToolip(row, col)"
          class="table-cell">
          {{ getTableCellValue(row, col) }}
        </span>
      </template>
    </Table>
  </div>
</template>

<script>
import {
  autoGamResolutionTableColumns,
  tableActionColumns,
  autoResolutionOutcomeOptions,
} from "@/config/disputeDataConstant.js";
import { format } from "date-fns";
import Notification from "@anchor/ui-components/src/components/Notification/Notification.vue";
import { isEmpty } from "@/utils/helpers.js";

export default {
  name: "AutoGamResolutionTable",
  components: {
    Notification,
  },
  props: {
    autoGamResolutionValues: {
      type: Array,
      default() {
        return [];
      },
    },
    isGamAlreadyCreated: {
      type: Boolean,
      default() {
        return false;
      },
    },
    selectedRows: { type: Array, default: () => [] },
    selectedRowByIds: { type: Array, default: () => [] },
  },
  data() {
    return {
      autoGamResolutionTableColumns,
      tableActionColumns,
      autoResolutionOutcomeOptions,
      data: this.autoGamResolutionValues?.filter(
        (item) =>
          item?.decision !== "Manual Charge" &&
          !item?.charge_type?.includes("[Manual Charge]")
      ),
      actionButtonText: "",
      isGamPresent: this.isGamAlreadyCreated,
    };
  },
  computed: {
    getData() {
      return this.data
        ?.filter(
          (item) =>
            item?.decision !== "Manual Charge" &&
            !item?.charge_type?.includes("[Manual Charge]")
        )
        ?.map((item) => {
          item = item?.isPotentialAccept
            ? { ...item, outcome: "accept" }
            : { ...item };
          if (item?.charge_type == "DMR" || item?.charge_type == "DET") {
            item = { ...item, expectedQuantity: "1" };
          }
          item.expectedAmount = item?.expectedAmount?.replaceAll("$", "");
          return item;
        });
    },
  },
  watch: {
    isGamAlreadyCreated() {
      this.isGamPresent = this.isGamAlreadyCreated;
    },
    autoGamResolutionValues() {
      this.data = this.autoGamResolutionValues;
    },
    data() {
      let buttonActionText = "";
      let disableActionButton = false;
      for (let index = 0; index < this.data?.length; index++) {
        let item = this.data?.[index];
        if (item?.outcome == "reject") {
          buttonActionText =
            "No GAM - Manual exisiting process need to followed";
          break;
        } else if (item?.outcome == "accept" && !item?.isPotentialAccept) {
          buttonActionText = "Create Manual GAM";
        } else if (
          item?.outcome == "accept" &&
          item?.isPotentialAccept &&
          buttonActionText != "Create Manual GAM"
        ) {
          buttonActionText = "Create Gam";
        }
      }
      for (let index = 0; index < this.data?.length; index++) {
        let item = this.data?.[index];
        if (
          item?.outcome == "accept" &&
          (isEmpty(item?.expectedAmount?.replaceAll("$", "")) ||
            isEmpty(item?.expectedQuantity) ||
            isNaN(item?.expectedQuantity) ||
            isNaN(item?.expectedAmount?.replaceAll("$", "")) ||
            Number(item?.expectedAmount?.replaceAll("$", "")) < 0 ||
            Number(item?.expectedQuantity) < 0) &&
          !item?.isPotentialAccept
        ) {
          disableActionButton = true;
          break;
        }
      }
      this.actionButtonText = buttonActionText;
      this.$emit(
        "getActionButtonText",
        buttonActionText,
        this.isGamAlreadyCreated ? true : disableActionButton,
        this.data
      );
    },
  },
  mounted() {
    this.data = this.data?.map((item) => {
      item = item?.isPotentialAccept
        ? { ...item, outcome: "accept" }
        : { ...item };
      if (item?.charge_type == "DMR" || item?.charge_type == "DET") {
        item = { ...item, expectedQuantity: "1" };
      }
      item.expectedAmount = item?.expectedAmount?.replaceAll("$", "");
      return item;
    });
  },
  methods: {
    validateAutoGamRow(row, slotKey) {
      return isEmpty(row?.[slotKey])
        ? `${
            slotKey == "expectedQuantity"
              ? "Expected quantity"
              : "Expected amount"
          } is required`
        : isNaN(row?.[slotKey]?.replaceAll("$", ""))
        ? `${
            slotKey == "expectedQuantity"
              ? "Expected quantity"
              : "Expected amount"
          } must be number.`
        : Number(row?.[slotKey]?.replaceAll("$", "")) < 0
        ? `${
            slotKey == "expectedQuantity" ? "This" : "This"
          } can not be negative`
        : "";
    },
    onAddNumber(event, row, slotKey) {
      let cloneData = [...this.data];
      const findDataIndex = this.data?.findIndex(
        (item) =>
          item?.charge_type?.toLowerCase() ===
            row?.charge_type?.toLowerCase() &&
          item?.decision?.toLowerCase() === row?.decision?.toLowerCase()
      );
      cloneData[findDataIndex][slotKey] = !isNaN(event) ? event : 1;
      this.data = cloneData;
    },
    onSubtractNumber(event, row, slotKey) {
      let cloneData = [...this.data];
      const findDataIndex = this.data?.findIndex(
        (item) =>
          item?.charge_type?.toLowerCase() ===
            row?.charge_type?.toLowerCase() &&
          item?.decision?.toLowerCase() === row?.decision?.toLowerCase()
      );
      cloneData[findDataIndex][slotKey] = !isNaN(event)
        ? event < 0
          ? 0
          : event
        : 0;
      this.data = cloneData;
    },
    onTextChange(event, row, slotKey) {
      let cloneData = [...this.data];
      const findDataIndex = this.data?.findIndex(
        (item) =>
          item?.charge_type?.toLowerCase() ===
            row?.charge_type?.toLowerCase() &&
          item?.decision?.toLowerCase() === row?.decision?.toLowerCase()
      );
      cloneData[findDataIndex][slotKey] = event?.target.value;
      this.data = cloneData;
    },
    selectChangeEvent(selectedItems) {
      this.$emit("onMultiSelectRow", selectedItems);
    },
    updateActiveRowRecord(row) {
      this.$emit("updateActiveRow", row);
    },
    checkIsDisabled(row) {
      return row.isPotentialAccept;
    },
    onSelectOutcome(selectedValue, row) {
      let cloneData = [...this.data];
      const findIndex = this.autoResolutionOutcomeOptions.findIndex(
        (item) =>
          item?.value?.toLowerCase() === selectedValue?.value?.toLowerCase()
      );
      const findDataIndex = this.data?.findIndex(
        (item) =>
          item?.charge_type?.toLowerCase() ===
            row?.charge_type?.toLowerCase() &&
          item?.decision?.toLowerCase() === row?.decision?.toLowerCase()
      );
      if (findIndex > -1 && findDataIndex > -1) {
        cloneData[findDataIndex].outcome =
          this.autoResolutionOutcomeOptions[findIndex]?.value;
      } else {
        cloneData[findDataIndex].outcome = selectedValue;
      }
      this.data = [...cloneData];
    },
    getTableCellValue(row, col) {
      const value = row[col.slotKey];
      if (col.type === "date") {
        try {
          return value ? format(new Date(value), "dd-MMM-yyyy hh:mm a") : "N/A";
        } catch (err) {
          return value;
        }
      }
      return !value || typeof value === "undefined" || value === "null"
        ? "-"
        : value;
    },
    getTableCellValueToolip(row, col) {
      const value = row[col.slotKey];
      if (col.type === "date") {
        try {
          return value ? format(new Date(value), "dd-MMM-yyyy hh:mm a") : "N/A";
        } catch (err) {
          return value;
        }
      } else {
        return value;
      }
    },
    getOutcomeOptions(value) {
      const findIndex = this.autoResolutionOutcomeOptions.findIndex(
        (item) => item?.value?.toLowerCase() === value?.toLowerCase()
      );
      if (findIndex > -1) {
        return this.autoResolutionOutcomeOptions[findIndex]?.value;
      }
      return "";
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";

.auto-gam-resolution-table {
  overflow: auto;
  &__container {
    cursor: pointer;
    position: relative;
    margin-bottom: 16px;
  }
  &__notification {
    margin: 16px 0px;
  }
  .table-flex__row__cell {
    height: auto;
  }
}
</style>
